import { bl_fi_mst_entity_vehicle_model_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_model.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleModelContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_model: bl_fi_mst_entity_vehicle_model_RowClass = new bl_fi_mst_entity_vehicle_model_RowClass();
}
